export default "__VITE_ASSET__CdEE7l8___"